module.exports = __webpack_public_path__ + "static/media/trash.da2cbce9.svg";